 <template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="companies"
			:columns="columns"
			:current-page="currentPage"
			:rows="rows"
			:last-page="lastPage"
			:check-all="checkAll"
			selectable
			@on-search-event="onSearch"
			@on-page="changePage"
			@on-selected-all="$emit('on-selected-all', $event)"
			@row-is-selected="$emit('row-is-selected', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.nombreComercial }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.hash }}
				</td>
				<td v-show="showRow(columns, 3)">
					{{ props.row.razonSocial }}
				</td>
				<td v-show="showRow(columns, 4)">
					{{ props.row.codeCompany }}
				</td>
				<td v-show="showRow(columns, 5)">
					{{ props.row.ruc }}
				</td>
				<td v-show="showRow(columns, 6)">
					{{ props.row.namePlan }}
				</td>
				<td v-show="showRow(columns, 7)">
					{{ props.row.expirationDate }}
				</td>
				<td v-show="showRow(columns, 8)">
					{{ '-' }}
				</td>
				<td>
					<div class="d-flex align-center">
						<v-tooltip top v-if="codeProject === 'maki_project'"  >
							<v-btn
								flat
								icon
								small
								slot="activator"
								color="blue"
								@click="renewCompany(props.row)">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
									<rect x="8" y="12" width="48" height="44" rx="6" fill="white" stroke="#222" stroke-width="3"/>
									<line x1="8" y1="22" x2="56" y2="22" stroke="#222" stroke-width="3"/>
									
									<line x1="20" y1="6" x2="20" y2="18" stroke="#222" stroke-width="3" stroke-linecap="round"/>
									<line x1="44" y1="6" x2="44" y2="18" stroke="#222" stroke-width="3" stroke-linecap="round"/>

									<text x="20" y="46" font-size="20" font-family="Arial" fill="#222" font-weight="bold">28</text>

									<line x1="14" y1="16" x2="50" y2="52" stroke="#FF3B30" stroke-width="6" stroke-linecap="round"/>
									<line x1="50" y1="16" x2="14" y2="52" stroke="#FF3B30" stroke-width="6" stroke-linecap="round"/>
								</svg>
							</v-btn>
							<span>Renovar 1 año</span>
						</v-tooltip>
						<app-tooltip-button
							color="green"
							icon="edit"
							text="Editar Compañía"
							@click-icon="edit(props.row)"
						/>
						<app-tooltip-button
							color="blue"
							icon="people_outline"
							text="Usuarios"
							@click-icon="goToUsers(props.row)"
						/>
						<app-tooltip-button
							color="red"
							icon="playlist_add_check"
							text="Roles"
							@click-icon="openRoles(props.row)"
						/>
						<v-tooltip top>
							<v-switch
								slot="activator"
								color="green"
								class="mt-0"
								hide-details
								v-model="props.row.flagBlocked"
								@change="blockedCompany(props.row)"
							></v-switch>
							<span class="text-center">{{ props.row.flagBlocked ? 'Desbloquear' : 'Bloquear' }} compañía</span>
						</v-tooltip>
					</div>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function changePage(page) {
	this.$emit('change-page', page);
}

function edit({ id, nombreComercial, codeCompany }) {
	const idCompany = id;
	const nameCompany = nombreComercial;
	this.goTo('page-edit-company', { params: { idCompany, codeCompany, nameCompany } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function openRoles({ codeCompany }) {
	this.goTo('page-role', { params: { codeCompany, codeProject: this.codeProject } });
}

function goToUsers({ codeCompany }) {
	this.goTo('page-user', { params: { codeProject: this.codeProject, idCompany: codeCompany } });
}

async function renewCompany({ id, nombreComercial }) {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	try {
		const conf = confirm(`¿Estás seguro de que deseas renovar 1 año para ${nombreComercial || 'esta empresa'}?`);
		 if (conf) {
			await this.$http.patch(`company-renewal/${id}`, null, { headers });
			this.showNotification(`Se renovo la compañía ${nombreComercial} correctamente`);
		 }
	} catch (error) {
		this.showNotification('No se pudo renovar la compañía', 'error');
	}
}

export default {
	name: 'companies-list',
	components: {
		appTooltipButton,
	},
	props: {
		codeProject: {
			type: String,
			required: true,
		},
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
		checkAll: {
			type: Boolean,
			default: false,
		}
	},
	methods: {
		changePage,
		edit,
		onSearch,
		openRoles,
		goToUsers,
		async blockedCompany(row) {
			const { flagBlocked, id, nombreComercial } = row;
			const message = flagBlocked ? 'bloqueo' : 'desbloqueo';
			const body = {
				flagBlocked: flagBlocked ? 1 : 0,
			};
			try {
				await this.$http.patch(`company/${id}/blocked`, body);
				this.showNotification(`Se ${message} la compañía ${nombreComercial} correctamente`);
			} catch (error) {
				this.showNotification('No se pudo bloquear la compañía', 'error');
			}
		},
		renewCompany,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/companies/company-list.vue